import React from 'react';
import NavBar from '../components/navigation/NavBar';
import { useAuth } from '../contexts/AuthContext';
import { useSidebar } from '../contexts/SidebarContext';
import { Navigate, Outlet } from 'react-router-dom';
import LoadingScreen from '../components/common/LoadingScreen';
import SecurityBanner from '../components/common/SecurityBanner';

const MainLayout = () => {
  const { user, loading } = useAuth();
  const { isSidebarCollapsed } = useSidebar();

  if (loading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="flex flex-col h-screen bg-gray-100 overflow-hidden">
      <SecurityBanner />
      <div className="flex flex-1 overflow-hidden">
        <NavBar />

        {/* Main Content - Scrollable - dinamikus margin a sidebar szélessége alapján */}
        <div className={`flex-1 transition-all duration-300 md:pt-0 pt-24 ${
          isSidebarCollapsed ? 'md:ml-16' : 'md:ml-48 lg:ml-64'
        }`}>
          <div className="h-full overflow-auto p-4 sm:p-6 lg:p-8 [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-gray-200 [&::-webkit-scrollbar-thumb]:bg-gray-400 [&::-webkit-scrollbar-thumb]:rounded-full hover:[&::-webkit-scrollbar-thumb]:bg-primary-500/50">
          <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout; 